export default {
  'BE-THESAURUS': ['fr', 'nl'],
  'CD-ATC': ['fr', 'nl'],
  'CD-DRUG-CNK': ['fr', 'nl'],
  'CD-INNCLUSTER': ['fr', 'nl'],
  ICPC: ['fr', 'nl'],
  ICD: ['fr', 'nl'],
}
